/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global Office */
const mime = require("mime-types");

let _settings;
export let language, connectionUrl, userId, accessTokenExpireAt;

export const paneType = document.getElementById("container").dataset.paneType;
export let attachments = [];
export let subject;

Office.onReady(() => {
  // Get previous login information, except for password
  _settings = Office.context.roamingSettings;
  language = _settings.get("language");
  connectionUrl = _settings.get("connectionUrl");
  userId = _settings.get("userId");

  if (paneType === "read") {
    const item = Office.context.mailbox.item;
    subject = item.subject;

    if (item.attachments.length > 0) {
      for (let i = 0; i < item.attachments.length; i++) {
        const attachment = item.attachments[i];
        attachments.push({
          name: attachment.name,
          id: attachment.id,
        })
      }
    }
  }
});

export function setAddInSettings(nameValuePairs) {
  for (const [name, value] of Object.entries(nameValuePairs)) {
    _settings.set(name, value);
  }
  _settings.saveAsync();
}

export async function downloadAttachment(attachmentId, attachmentName) {
  return new Promise((resolve, reject) => {
    Office.context.mailbox.item.getAttachmentContentAsync(
      attachmentId,
      { asyncContext: attachmentName },
      async function (result) {
        if (result.status !== Office.AsyncResultStatus.Succeeded) {
          reject(result.error.message);
        }
        console.log("Attachment content", result.value);
        switch (result.value.format) {
          case Office.MailboxEnums.AttachmentContentFormat.Base64:
            resolve(result.value.content);
            break;
          case Office.MailboxEnums.AttachmentContentFormat.Eml:
            // Leaving this case for future development
            reject("Attachment format is not supported");
            break;
          case Office.MailboxEnums.AttachmentContentFormat.ICalendar:
            // Leaving this case for future development
            reject("Attachment format is not supported");
            break;
          case Office.MailboxEnums.AttachmentContentFormat.Url:
            // Leaving this case for future development
            reject("Attachment format is not supported");
            break;
          default:
            reject("Attachment format is not supported");
        }
      },
    );
  });
}

async function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export async function addAttachmentToEmail(blob, attachmentName) {
  const base64Data = await blobToBase64(blob);
  const base64DataWithoutPrefix = base64Data.substring(base64Data.indexOf(',') + 1);

  return new Promise((resolve, reject) => {
    Office.context.mailbox.item.addFileAttachmentFromBase64Async(
      base64DataWithoutPrefix,
      attachmentName,
      {
        isInline: false
      },
      function (result) {
        if (result.status === Office.AsyncResultStatus.Failed) {
          reject(result.error.message);
        }
        resolve();
      }
    )
  });
}
